export default __webpack_public_path__ + "static/media/860.6c7cb449.png";